export const setBoard = (data) => {
   return {
      type: "SET_BOARD",
      payload: data,
   };
};
export const setBoardRole = (data) => {
   return {
      type: "SET_BOARD_ROLE",
      payload: data,
   };
};
export const setSheet = (data) => {
   return {
      type: "SET_SHEET",
      payload: data,
   };
};
export const changeTabsOrder = (data) => {
   return {
      type: "CHANGE_TABS_ORDER",
      payload: data,
   };
};
export const addSheet = (data) => {
   return {
      type: "ADD_SHEET",
      payload: data,
   };
};
export const editSheet = (data) => {
   return {
      type: "EDIT_SHEET",
      payload: data,
   };
};
export const deleteSheet = (data) => {
   return {
      type: "DELETE_SHEET",
      payload: data,
   };
};
export const addBoard = (data) => {
   return {
      type: "ADD_BOARD",
      payload: data,
   };
};
export const editBackgroundSheet = (data) => {
   return {
      type: "EDIT_BACKGROUND_SHEET",
      payload: data,
   };
};
export const editTabsSheet = (data) => {
   return {
      type: "EDIT_TABS_SHEET",
      payload: data,
   };
};
export const setWidgetInSheetParams = (data) => {
   return {
      type: "SET_WIDGET_IN_SHEET_PARAMS",
      payload: data,
   };
};
export const setClickedRow = (data) => {
   return {
      type: "SET_CLICKED_ROW",
      payload: data,
   };
};
export const setDateStart = (data) => {
   return {
      type: "SET_DATE_START",
      payload: data,
   };
};
export const setPropertyInWidget = (data) => {
   return {
      type: "SET_PROPERTY_IN_WIDGET",
      payload: data,
   };
};
export const changeWidgetsOrder = (data) => {
   return {
      type: "CHANGE_WIDGETS_ORDER",
      payload: data,
   };
};
export const addWidgetInSheet = (data) => {
   return {
      type: "ADD_WIDGET_IN_SHEET",
      payload: data,
   };
};
export const deleteWidgetInSheet = (data) => {
   return {
      type: "DELETE_WIDGET_IN_SHEET",
      payload: data,
   };
};
export const setAllSheets = (data) => {
   return {
      type: "SET_ALL_SHEETS",
      payload: data,
   };
};
export const setBoardColumns = (data) => {
   return {
      type: "SET_BOARD_COLUMNS",
      payload: data,
   };
};

export const setUserBoards = (boards) => {
   return {
      type: "SET_USER_BOARDS",
      payload: boards,
   };
};
